module.exports = __webpack_public_path__ + "static/media/mail-icon.68452848.png";